var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.651 0C6.64257 0 1.77148 4.37292 1.77148 9.76744C1.77148 12.4187 2.9479 14.8233 4.85827 16.583C4.35738 16.9421 4.03668 17.4947 4.03668 18.1144C4.03668 19.1956 5.01324 20.0723 6.21763 20.0723C7.18712 20.0723 8.0087 19.5045 8.29281 18.7192C9.62727 19.2437 11.1013 19.5343 12.651 19.5343C18.6601 19.5343 23.5312 15.1614 23.5312 9.76744C23.5312 4.37292 18.6601 0 12.651 0ZM6.14107 12.6967L6.02208 12.0662L8.10125 8.09551L8.09541 8.06459L5.60298 8.44386L5.42003 7.47471L9.60851 6.83762L9.73643 7.51418L7.70829 11.43L7.71444 11.4606L10.447 11.0449L10.6297 12.0138L6.14107 12.6967ZM14.3157 12.3925H11.0048V11.9271L13.0329 9.30674V9.28411H11.1945V8.56946H14.284V9.06853L12.3002 11.655V11.6776H14.316V12.3925H14.3157ZM19.8036 8.03837L16.6827 11.324L16.6793 11.3549L19.4362 11.6111L19.3233 12.5885L14.7951 12.1681L14.8683 11.5318L18.055 8.20537L18.0587 8.17418L15.5438 7.94065L15.6563 6.96322L19.882 7.35574L19.8036 8.03837Z",
    fill: "#3F94B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.49346 22.5433C4.25356 22.5433 4.86974 21.9902 4.86974 21.3078C4.86974 20.6254 4.25356 20.0723 3.49346 20.0723C2.73337 20.0723 2.11719 20.6254 2.11719 21.3078C2.11719 21.9902 2.73337 22.5433 3.49346 22.5433Z",
    fill: "#3F94B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.960565 24C1.49107 24 1.92113 23.614 1.92113 23.1377C1.92113 22.6615 1.49107 22.2754 0.960565 22.2754C0.430059 22.2754 0 22.6615 0 23.1377C0 23.614 0.430059 24 0.960565 24Z",
    fill: "#3F94B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepIcon);
export default __webpack_public_path__ + "static/media/sleepIcon.9ddb8bc94867eabaa37bd67c7c755d12.svg";
export { ForwardRef as ReactComponent };